import "./ItensMenu.css";

const ItensMenu = (props) => {

    const ClassNameMenu = `menu-item ${props.active}`;
    const IconeMenu = `${props.icone}`;
    const NomeMenu = `${props.nome}`;
    const LinkMenu = `${props.link}`;

    return (
        <a href={LinkMenu} className={ClassNameMenu}>
            <span className="menu-icon">{IconeMenu}</span>
            <span className="menu-text">{NomeMenu}</span>
        </a>
    );
};

export default ItensMenu;